import { computed, makeObservable } from 'mobx';
import { Trans } from 'react-i18next';
import { ProcessPage } from 'src/components/FormPages/ProcessPage';
import { RoutePaths } from 'src/core/router/RoutePaths';
import { featureList } from 'src/featureList';
import { SettingsScoringModelPageDetails } from 'src/pages/SettingsPage/components';
import { DocumentTemplateList } from 'src/pages/SettingsPage/components/DocumentTemplates/DocumentTemplateList';
import { InterestRateDetails } from 'src/pages/SettingsPage/components/InterestRateDetails';
import { LandingPageDetails } from 'src/pages/SettingsPage/components/LandingPage/LandingPageDetails';
import { LandingPageEdit } from 'src/pages/SettingsPage/components/LandingPage/LandingPageEdit';
import { LicenseKeyDetails } from 'src/pages/SettingsPage/components/LicenseKeyDetails';
import { NotificationTemplateEdit } from 'src/pages/SettingsPage/components/NotificationTemplates/NotificationTemplateEdit';
import { NotificationTemplateList } from 'src/pages/SettingsPage/components/NotificationTemplates/NotificationTemplateList';
import { RouteDefinition } from 'src/stores/RouterStore/RouterStore.types';
import {
    filterMenuItems,
    ifFeatureUnavailable,
} from 'src/stores/RouterStore/utils';
import { SettingsDocumentationTemplatesStore } from 'src/stores/SettingsStores/SettingsDocumentationTemplatesStore/SettingsDocumentationTemplatesStore';
import { SettingsNotificationTemplatesStore } from 'src/stores/SettingsStores/SettingsNotificationTemplatesStore/SettingsNotificationTemplatesStore';

export class SettingsRouterStoreClass {
    constructor() {
        makeObservable(this);
    }

    @computed get routes(): RouteDefinition[] {
        return [
            {
                key: RoutePaths.settingsInterestRate,
                path: RoutePaths.settingsInterestRate,
                exact: true,
                Component: InterestRateDetails,
                menuTitle: () => (
                    <Trans i18nKey="Page.Setting.List.Item.Interest rate" />
                ),
                unavailable: ifFeatureUnavailable([
                    featureList.settings.unavailable,
                ]),
            },
            {
                key: `${RoutePaths.settingsInterestRate}-process`,
                path: `${RoutePaths.settingsInterestRate}/process/:processKey`,
                render: () => {
                    return (
                        <ProcessPage
                            baseUrl={RoutePaths.settingsInterestRate}
                        />
                    );
                },
                unavailable: ifFeatureUnavailable([
                    featureList.settings.unavailable,
                ]),
            },
            {
                key: RoutePaths.settingsApplicationLicense,
                path: RoutePaths.settingsApplicationLicense,
                exact: true,
                Component: LicenseKeyDetails,
                menuTitle: () => (
                    <Trans i18nKey="Page.Setting.List.Item.License key" />
                ),
                unavailable: ifFeatureUnavailable([
                    featureList.settings.unavailable,
                ]),
            },
            {
                key: RoutePaths.settingsLandingPage,
                path: RoutePaths.settingsLandingPage,
                exact: true,
                Component: LandingPageDetails,
                menuTitle: () => (
                    <Trans i18nKey="Page.Setting.List.Item.Landing page" />
                ),
                unavailable: ifFeatureUnavailable([
                    featureList.settings.unavailable,
                ]),
            },
            {
                key: RoutePaths.settingsLandingPageEdit,
                path: RoutePaths.settingsLandingPageEdit,
                exact: true,
                Component: LandingPageEdit,
                unavailable: ifFeatureUnavailable([
                    featureList.settings.unavailable,
                ]),
            },
            {
                key: RoutePaths.settingsScoringModel,
                path: RoutePaths.settingsScoringModel,
                exact: false,
                Component: SettingsScoringModelPageDetails,
                menuTitle: () => (
                    <Trans i18nKey="Page.Setting.List.Item.Scoring model" />
                ),
                unavailable: ifFeatureUnavailable([
                    featureList.settings.unavailable,
                ]),
            },
            {
                key: RoutePaths.settingsDocumentTemplates,
                path: RoutePaths.settingsDocumentTemplates,
                exact: true,
                Component: DocumentTemplateList,
                menuTitle: () => (
                    <Trans i18nKey="Page.Setting.List.Item.Document templates" />
                ),
                unavailable: ifFeatureUnavailable([
                    featureList.settings.unavailable,
                ]),
            },
            {
                key: RoutePaths.settingsDocumentTemplatesProcess,
                path: RoutePaths.settingsDocumentTemplatesProcess,
                exact: true,
                render: () => {
                    return (
                        <ProcessPage
                            baseUrl={RoutePaths.settingsDocumentTemplates}
                            store={SettingsDocumentationTemplatesStore}
                        />
                    );
                },
                unavailable: ifFeatureUnavailable([
                    featureList.settings.unavailable,
                ]),
            },
            {
                key: RoutePaths.settingsNotificationTemplates,
                path: RoutePaths.settingsNotificationTemplates,
                exact: true,
                Component: NotificationTemplateList,
                menuTitle: () => (
                    <Trans i18nKey="Page.Setting.List.Item.Notification templates" />
                ),
                unavailable: ifFeatureUnavailable([
                    featureList.settings.unavailable,
                ]),
            },
            {
                key: RoutePaths.settingsNotificationTemplateEdit,
                path: RoutePaths.settingsNotificationTemplateEdit,
                exact: true,
                Component: NotificationTemplateEdit,
                unavailable: ifFeatureUnavailable([
                    featureList.settings.unavailable,
                ]),
            },
            {
                key: RoutePaths.settingsNotificationTemplateProcess,
                path: RoutePaths.settingsNotificationTemplateProcess,
                exact: true,
                render: () => {
                    return (
                        <ProcessPage
                            baseUrl={RoutePaths.settingsNotificationTemplates}
                            store={SettingsNotificationTemplatesStore}
                        />
                    );
                },
                unavailable: ifFeatureUnavailable([
                    featureList.settings.unavailable,
                ]),
            },
        ];
    }

    @computed get menuItems(): RouteDefinition[] {
        return filterMenuItems(this.routes);
    }
}

export const SettingsRouterStore = new SettingsRouterStoreClass();
